import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PerformanceTrackerService {

  // appurl = environment.apiUrl + '/V2/api/survey';
  // access = JSON.parse(localStorage.getItem('access'));
  // GET_STUDY_VISIBLITY = environment.apiUrl + '/v2/api/getStudyVisibility';
  // GET_DOWNLOADED_REPORT = environment.apiUrl + '/v2/api/report/download';
  // GET_DOWNLOADED_QUOTA_REPORT = environment.apiUrl + '/api/quota-localization';
  // GET_FUNNEL_DOWNLOAD = environment.apiUrl + '/v2/api/funnel/download';
  // GET_AR_DATA = environment.apiUrl + '/survey/food/performance-tracker';
  // GET_BILL_ANALYSIS = environment.apiUrl + '/survey/itc/item-analysis';
  // GET_BILL_ANALYSIS_ITEM_WISE = environment.apiUrl + '/survey/itc/item-analysis/item-wise';
  // GET_SUBCAT_WISE_WISE = environment.apiUrl + '/survey/itc/item-analysis/subcategories-wise';

  appurl = '/V2/api/survey';
  access = JSON.parse(localStorage.getItem('access'));
  GET_STUDY_VISIBLITY = '/v2/api/getStudyVisibility';
  GET_DOWNLOADED_REPORT = '/v2/api/report/download';
  GET_DOWNLOADED_QUOTA_REPORT = '/api/quota-localization';
  GET_FUNNEL_DOWNLOAD = '/v2/api/funnel/download';
  GET_AR_DATA = '/survey/food/performance-tracker';
  GET_BILL_ANALYSIS = '/survey/itc/item-analysis';
  GET_BILL_ANALYSIS_ITEM_WISE = '/survey/itc/item-analysis/item-wise';
  GET_SUBCAT_WISE_WISE = '/survey/itc/item-analysis/subcategories-wise';
  GET_SURVEY_DATA = '/v2/api/survey/getData/';


  surveyDetails: any;

  private httpPostOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true
  };

  private apiRequestHttpOptions:any = {
    httpOptions:this.httpPostOptions
  };

  constructor(private http: HttpClient, private apiRequest: ApiRequestService) {}

  getQuotaDetails(studyId: string) {
    this.surveyDetails = {survey_id: studyId}
    let pathUrl = this.appurl + '/quotaDetails';
    return this.apiRequest.request('POST',pathUrl,this.surveyDetails,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.appurl + '/quotaDetails', this.surveyDetails,  this.httpPostOptions);
  }
  
  getSubQuotaDetails(studyId: string, quotaId: string) {
    this.surveyDetails = {user_uuid: this.access.id, survey_id: studyId, quotaId:quotaId}
    let pathUrl = this.appurl + '/quotaDetails';
    return this.apiRequest.request('POST',pathUrl,this.surveyDetails,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.appurl + '/quotaDetails', this.surveyDetails,  this.httpPostOptions);
  }

  getResponseDateQuota(studyId: string){
    // localStorage.setItem('studyId',studyId);
    sessionStorage.setItem('studyId',studyId);
    this.surveyDetails = {user_uuid: this.access.id, survey_id: studyId}
    let pathUrl = this.appurl + '/responseDateQuota';
    return this.apiRequest.request('POST',pathUrl,this.surveyDetails,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.appurl + '/responseDateQuota', this.surveyDetails,  this.httpPostOptions);
  }

  getDailyResponseRate(studyId: string, startDate, endDate){
    this.surveyDetails = {user_uuid: this.access.id, survey_id: studyId, startDate : startDate, endDate: endDate}
    let pathUrl = this.appurl + '/dailyResponseRate';
    return this.apiRequest.request('POST',pathUrl,this.surveyDetails,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.appurl + '/dailyResponseRate', this.surveyDetails,  this.httpPostOptions);
  }

  getStudyVisibility(studyId: string){
    this.surveyDetails = {study_id: studyId}
    return this.apiRequest.request('POST',this.GET_STUDY_VISIBLITY,this.surveyDetails,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.GET_STUDY_VISIBLITY, this.surveyDetails,  this.httpPostOptions);
  }

  getPtDetails(pt_uuid: string){
    // this.surveyDetails = {pt_id: ptId}
    return this.apiRequest.request('POST','/v2/api/pt-details',{pt_uuid: pt_uuid},this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.GET_STUDY_VISIBLITY, this.surveyDetails,  this.httpPostOptions);
  }

  getDownloadQuotaReport(studyId: string){
    this.surveyDetails = {uuid: studyId}
    return this.apiRequest.request('POST',this.GET_DOWNLOADED_QUOTA_REPORT,this.surveyDetails,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.GET_DOWNLOADED_QUOTA_REPORT, this.surveyDetails,  this.httpPostOptions);
  }

  getDownloadReport(studyId: string, requestType: string){
    this.surveyDetails = {study_id: studyId, requestType: requestType}
    return this.apiRequest.request('POST',this.GET_DOWNLOADED_REPORT,this.surveyDetails,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.GET_DOWNLOADED_REPORT, this.surveyDetails,  this.httpPostOptions);
  }

  funnelReport(studyId:any){
    return this.apiRequest.request('POST',this.GET_FUNNEL_DOWNLOAD,{study_id:studyId},this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.GET_FUNNEL_DOWNLOAD, {study_id:studyId},  this.httpPostOptions);
  }

  getARData(data:any){
    return this.apiRequest.request('POST',this.GET_AR_DATA,data,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.GET_AR_DATA, data, this.httpPostOptions);
  }

  getBillAnalysisData(data){
    return this.apiRequest.request('POST',this.GET_BILL_ANALYSIS,data,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.GET_BILL_ANALYSIS, data, this.httpPostOptions);
  }

  getItemWiseData(data){
    return this.apiRequest.request('POST',this.GET_BILL_ANALYSIS_ITEM_WISE,data,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.GET_BILL_ANALYSIS_ITEM_WISE, data, this.httpPostOptions);
  }

  getSubCategoryWiseData(data){
    return this.apiRequest.request('POST',this.GET_SUBCAT_WISE_WISE,data,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.GET_SUBCAT_WISE_WISE, data, this.httpPostOptions);
  }

  getSurveyDataBaseOnStudyId(studyId:any){
    let route = this.appurl+'/getData/'+studyId;
    return this.apiRequest.request('GET',route,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
  }

}
